import { PageHeader } from "antd";
import LayoutCss from "../../../layout/layout.module.scss";
import { ClientReportConfigsContainer } from "./clientReportConfigsContainer/clientReportConfigsContainer";

export const Reports = () => {
  return (
    <>
      <PageHeader
        ghost={false}
        title="Reports"
        className={LayoutCss.appPageHeader}
      />
      <ClientReportConfigsContainer />
    </>
  );
};
